import { createApi } from '@reduxjs/toolkit/query/react';
import { BackendResponse } from '../../types';
import { parseQueryParams } from '../../utils';
import { baseQueryWithReauth } from './baseQuery';

const systemConfigApi = createApi({
  reducerPath: 'systemConfig',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['SystemConfig'],
  endpoints: builder => ({
    createSystemConfig: builder.mutation<BackendResponse<any>, any>({
      query: body => ({
        url: '/master/system-config',
        method: 'POST',
        body,
      }),
      invalidatesTags: (_, error) => (error ? [] : ['SystemConfig']),
    }),

    getSystemConfigs: builder.query<BackendResponse<any>, any | void>({
      query: params => ({
        url: `/master/system-config${params ? parseQueryParams(params) : ''}`,
        method: 'GET',
      }),
      providesTags: (_, error) => (error ? [] : ['SystemConfig']),
    }),

    updateSystemConfig: builder.mutation<
      BackendResponse<any>,
      { id: number | string; [key: string]: any }
    >({
      query: ({ id, ...body }) => ({
        url: `/master/system-config/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (_, error) => (error ? [] : ['SystemConfig']),
    }),

    toggleSystemConfigEnabled: builder.mutation<
      BackendResponse<any>,
      { id: number | string; isEnabled: boolean }
    >({
      query: ({ id, isEnabled }) => ({
        url: `/master/system-config/${id}/is-enabled`,
        method: 'PATCH',
        body: { isEnabled },
      }),
      invalidatesTags: (_, error) => (error ? [] : ['SystemConfig']),
    }),

    deleteSystemConfig: builder.mutation<BackendResponse<any>, number | string>({
      query: id => ({
        url: `/master/system-config/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, error) => (error ? [] : ['SystemConfig']),
    }),
  }),
});

export const {
  useCreateSystemConfigMutation,
  useGetSystemConfigsQuery,
  useUpdateSystemConfigMutation,
  useDeleteSystemConfigMutation,
  useToggleSystemConfigEnabledMutation,
} = systemConfigApi;

export default systemConfigApi;

